export const NOTIFICATIONLIST = "NOTIFICATIONLIST"
export const NOTIFICATIONADD = "NOTIFICATIONADD"
